export const tabsTokens = {
  tabs: {
    tablist: {
      background: 'transparent',
      borderColor: 'transparent',
      borderWidth: '0'
    },
    tab: {
      background: 'transparent',
      hoverBackground: 'transparent',
      activeBackground: 'transparent',
      borderWidth: '0 0 2px 0',
      borderColor: 'transparent',
      padding: '0 0 0.25rem 0',
      fontWeight: '400',
      margin: '0',
      gap: '0.5rem',
      focusRing: {
        shadow: 'none',
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0'
      },
      colorScheme: {
        light: {
          color: '{surface.800}',
          hoverColor: '{surface.900}',
          hoverBorderColor: '{surface.400}',
          activeColor: '{text.color}',
          activeBorderColor: 'transparent'
        }
      }
    },
    activeBar: {
      height: '2px',
      bottom: '0',
      background: '{orange.100}'
    },
    tabpanel: {
      padding: '1.5rem 0 0 0',
      background: 'transparent',
      color: '{text.color}',
      focusRing: {
        shadow: 'none',
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0'
      }
    }
  }
};

export type TabsTokens = typeof tabsTokens;
